export default "__VITE_ASSET__A8hWft_B__"